package com.appsyde.shared.modules.ticket.domain.usecase

import com.appsyde.shared.modules.ticket.domain.model.AssignUpToResult
import com.appsyde.shared.modules.ticket.domain.repository.TicketsRepository

class AssignUpToUseCase(
    private val repo: TicketsRepository
) {
    suspend operator fun invoke(count: Int = 2): AssignUpToResult = repo.assignUpTo(count)
}
